module.exports = __webpack_public_path__ + "static/media/second-reward.2a9d6352.svg";